import {types} from './types';

const initialState = {
    list: {
        list: [],
        page: 1
    },
}

export function presentReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_PRESENT:
            return { ...state, list: action.payload};
        default:
            return state
    }
}